import type { Theme } from 'react-select';
import type { ThemeTokens } from './tokens';
import { getShapeRadii } from './tokens';
import { mixColors } from './colorUtils';

/** Maps app theme tokens to react-select's theme callback shape. */
export const buildReactSelectTheme = (tokens: ThemeTokens) => (baseTheme: Theme): Theme => ({
    ...baseTheme,
    borderRadius: getShapeRadii(tokens.shape).md,
    colors: {
        ...baseTheme.colors,
        primary: tokens.primary,
        primary25: mixColors(tokens.primary, '#ffffff', 0.82),
        primary50: mixColors(tokens.primary, '#ffffff', 0.62),
        primary75: mixColors(tokens.primary, '#ffffff', 0.38),
    },
});
